import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listRewardPoints, updateRewardPoints } from "../../Redux/Actions/rewardsAction";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";
import { columnsRewardsPoints } from "../../Global Functions/columnsAntd";

const ListRewardPoints = () => {
  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


  const fetchDetails = (page, limit) => {
    const payload = {
      page,
      limit,
      is_deleted: false,
    };
    dispatch(listRewardPoints(payload));
  };


  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const rewardPoints = useSelector((state) => state.rewards?.pointsList || {});
  useEffect(() => {
    console.log("API Data:", rewardPoints?.data?.[0]); // See exact fields
  }, [rewardPoints]);

  useEffect(() => {
    if (rewardPoints?.total) {
      setPagination((prev) => ({
        ...prev,
        total: rewardPoints.total,
      }));
    }
  }, [rewardPoints]);

  const handleTableChange = (pager) => {
    setPagination(pager);
    // fetchDetails(pager.current, pager.pageSize);
  };

  const handleStatusChange = async (record, action) => {
    if (action === "active" || action === "inactive") {
      const payload = {
        id: record._id,
        status: action,
      };
      await dispatch(updateRewardPoints(payload));
      fetchDetails(pagination.current, pagination.pageSize);
    }
  };

  return (
    <TableComponentsCp
      h3heading="Reward Points List"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsRewardsPoints(handleStatusChange, canEdit)}
      buttonhead2={canAdd ? "Add Reward Points" : null}
      navigateTo2={canAdd ? "/rewards_point/add" : null}
      dataSource={Array.isArray(rewardPoints?.data) ? rewardPoints?.data : []}
    />
  );
};

export default ListRewardPoints;
